import { render, staticRenderFns } from "./contributionListPC.vue?vue&type=template&id=b4d3c050&scoped=true"
import script from "./contributionListPC.vue?vue&type=script&lang=js"
export * from "./contributionListPC.vue?vue&type=script&lang=js"
import style0 from "./contributionListPC.vue?vue&type=style&index=0&id=b4d3c050&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d3c050",
  null
  
)

export default component.exports